import { render, staticRenderFns } from "./person_change.vue?vue&type=template&id=3dfb64a6&scoped=true&"
import script from "./person_change.vue?vue&type=script&lang=js&"
export * from "./person_change.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dfb64a6",
  null
  
)

export default component.exports